import React, { useState } from "react"
import { Container, Row, Col, Card, CardBody, CardTitle, Table, Badge, Button, Spinner, Alert, Input, Form, FormGroup, Label } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { useGetTestsQuery } from "../../store/tests/tests.api"

const TestHistory = () => {
  const [filters, setFilters] = useState({
    limit: 20,
    status: "",
    type: "",
  })
  
  const { data, isLoading, error, refetch } = useGetTestsQuery(filters)
  
  const handleFilterChange = (e) => {
    const { name, value } = e.target
    setFilters({
      ...filters,
      [name]: value
    })
  }
  
  const handleFilterSubmit = (e) => {
    e.preventDefault()
    refetch()
  }
  
  const getStatusBadge = (status) => {
    switch (status) {
      case 'success':
        return <Badge color="success">Success</Badge>
      case 'failed':
        return <Badge color="danger">Failed</Badge>
      case 'pending':
        return <Badge color="warning">Pending</Badge>
      case 'running':
        return <Badge color="info">Running</Badge>
      case 'canceled':
        return <Badge color="secondary">Canceled</Badge>
      default:
        return <Badge color="primary">{status}</Badge>
    }
  }
  
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Test History" breadcrumbItem="Test History" />
        
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle>Filter Tests</CardTitle>
                  <Link to="/run-test" className="btn btn-primary">
                    Run New Test
                  </Link>
                </div>
                
                <Form onSubmit={handleFilterSubmit}>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="status">Status</Label>
                        <Input
                          type="select"
                          name="status"
                          id="status"
                          value={filters.status}
                          onChange={handleFilterChange}
                        >
                          <option value="">All Statuses</option>
                          <option value="success">Success</option>
                          <option value="failed">Failed</option>
                          <option value="running">Running</option>
                          <option value="pending">Pending</option>
                          <option value="canceled">Canceled</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="type">Type</Label>
                        <Input
                          type="select"
                          name="type"
                          id="type"
                          value={filters.type}
                          onChange={handleFilterChange}
                        >
                          <option value="">All Types</option>
                          <option value="simple">Simple</option>
                          <option value="comprehensive">Comprehensive</option>
                          <option value="performance">Performance</option>
                          <option value="security">Security</option>
                          <option value="reliability">Reliability</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="limit">Max Results</Label>
                        <Input
                          type="select"
                          name="limit"
                          id="limit"
                          value={filters.limit}
                          onChange={handleFilterChange}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button color="primary" type="submit">
                    Apply Filters
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Test History</CardTitle>
                
                {isLoading && (
                  <div className="text-center my-5">
                    <Spinner />
                    <p className="mt-2">Loading test history...</p>
                  </div>
                )}
                
                {error && (
                  <Alert color="danger">
                    {error.data?.message || "An error occurred while fetching test history"}
                  </Alert>
                )}
                
                {!isLoading && !error && data && (
                  data.length > 0 ? (
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Test Name</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Target System</th>
                          <th>Started At</th>
                          <th>Duration</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((test) => (
                          <tr key={test.id}>
                            <td>{test.name}</td>
                            <td>{test.type}</td>
                            <td>{getStatusBadge(test.status)}</td>
                            <td>{test.targetSystem}</td>
                            <td>{new Date(test.createdAt).toLocaleString()}</td>
                            <td>
                              {test.completedAt && test.createdAt 
                                ? `${Math.round((new Date(test.completedAt) - new Date(test.createdAt)) / 1000)}s` 
                                : '-'}
                            </td>
                            <td>
                              <Link 
                                to={`/run-test/results/${test.id}`} 
                                className="btn btn-sm btn-primary me-2"
                              >
                                View Results
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-center my-5">
                      <p>No test history found. Try running a test first.</p>
                      <Link to="/run-test" className="btn btn-primary mt-2">
                        Run a Test
                      </Link>
                    </div>
                  )
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default TestHistory 